<template>
  <div class="order-table-container small">
    <b-alert show variant="info" class="text-center">All pricing being provided during the inquiry are estimates.
      Final pricing will be provided once a Sales or Customer Service contacts you confirming your order.
      Inquiries not converted to an Order in 30 days will be canceled.
    </b-alert>
    <b-tabs class="mb-2" align="center" v-model="tabIndex">
      <b-tab title="Address"
        ><div class="my-4 container mobile-p-0">
          <div class="row d-flex align-items-stretch">
            <div :class="!sameAddress ? 'col-md-6 mb-3' : 'col-md-12'">
              <b-card class="my-2 px-0 h-100">
                <customer-form
                  :title="'Bill To'"
                  :showSameAddressCheckbox="true"
                  :sameAddress="sameAddress"
                  @handleShowBillingAddress="handleSameAddress"
                  :showShippingMethod="false"
                  :showMultiplier="true"
                  :showPOnumber="false"
                  ref="customerBillToForm"
                  :customers="customers"
                  :isBillTo="true"
                  :countries="countries"
                  :states="states"
                  :allowEmptyCustomer="false"
                  :data-cy="'bill-to-form'"
                />
              </b-card>
            </div>
            <div class="col-md-6 mb-3" v-show="!sameAddress">
              <b-card class="my-2 px-0 h-100">
                <customer-form
                  :title="'Ship To'"
                  ref="customerShipToForm"
                  :customers="customerShipTos"
                  :countries="countries"
                  :states="states"
                  :isBillTo="false"
                  :data-cy="'bill-ship-to'"
                />
              </b-card>
            </div>
            <div class="col-md-12 mt-2" data-cy="new-inquiry-contact-info">
              <b-card class="my-2">
                <h5 class="my-2">
                  <b>Contact Information</b>
                </h5>
                <b-row>
                  <b-col md="12">
                    <div class="form-group">
                      <label for="inquiry-contact-name">Job Name</label>
                      <input
                        type="text"
                        id="inquiry-contact-name"
                        class="form-control"
                        v-model.trim="inquiryContact.JobName"
                        :class="{
                          'is-invalid': contactErrors.JobName,
                        }"
                      />
                      <div v-if="contactErrors.JobName" class="invalid-feedback">
                        {{ contactErrors.JobName }}
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="inquiry-contact-name">Contact Name</label>
                      <input
                        type="text"
                        id="inquiry-contact-name"
                        class="form-control"
                        v-model.trim="inquiryContact.Name"
                        :class="{
                          'is-invalid': contactErrors.Name,
                        }"
                      />
                    <div v-if="contactErrors.Name" class="invalid-feedback">
                      {{ contactErrors.Name }}
                    </div>
                    </div>
                  </b-col>
                  <div class="col-md-4">
                    <label for="Phone">Phone</label>
                    <input
                      type="tel"
                      id="Phone"
                      class="form-control"
                      v-model.trim="inquiryContact.Phone"
                      maxlength="10"
                      placeholder="(000) 000-0000"
                      @input="formatPhoneNumber"
                      :class="{
                        'is-invalid': contactErrors.Phone,
                      }"
                    />
                    <div v-if="contactErrors.Phone" class="invalid-feedback">
                      {{ contactErrors.Phone }}
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="email">Email</label>
                      <input
                        id="email"
                        class="form-control"
                        name="Email"
                        v-model.trim="inquiryContact.Email"
                        placeholder=""
                        type="email"
                        :class="{
                          'is-invalid': contactErrors.Email,
                        }"
                      />
                      <div v-if="contactErrors.Email" class="invalid-feedback">
                        {{ contactErrors.Email }}
                      </div>
                    </div>
                  </div>
                </b-row>
              </b-card>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Items" data-cy="items-tab-testing">
        <div class="my-4">
          <cart-items @handleAction="addBlankItem" :showSuggestedPrice="true" @handleBrowse="onBrowse" :customerNumber="currentCustomer"/>
          <product-finder
            :findingModel="showModelFinder"
            @close="closeModelFinder"
            :isUsedByOrdersSite="true"
            :showTopologyTabOnly="true"
          ></product-finder>
        </div
      ></b-tab>
      <b-tab title="Comments"
        ><div class="my-4 container">
          <inquiry-comments-form ref="inquiryComments" /></div
      ></b-tab>
    </b-tabs>
    <div class="container">
      <div class="my-4 row">
        <div class="col-sm-12 col-md-6 my-2">
          <b-button
            block
            variant="outline-primary"
            class="color-primary border-primary"
            @click="updateNext(-1)"
            :disabled="tabIndex <= 0 || isSubmittingInquiry"
          >
            Back
          </b-button>
        </div>
        <div class="col-sm-12 col-md-6 my-2">
          <b-button
            block
            variant="primary"
            class="background-color-primary"
            @click="updateNext(+1)"
            :disabled="tabIndex == 3 || isSubmittingInquiry"
            :data-cy="'new-inquiry-btn'"
          >
            <template v-if="isSubmittingInquiry">
              <loading loadingText="Submitting"></loading>
            </template>
            <template v-else>
              {{ tabIndex == 2 ? ($route.params.fromInquiry ? 'Save Inquiry' : 'Create Inquiry') : 'Next' }}
            </template>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Watch } from 'vue-property-decorator'

import _ from 'lodash'
import CartItems from '@/components/cart/cart-items.vue'
import CustomerForm from '@/components/inquiries/new-inquiry/customer-form.vue'
import InquiryCommentsForm from './inquiry-comments.vue'
import ProductFinder from '@/components/modals/product-model-finder.vue'
import Loading from '@/components/utility/loading.vue'
import MxSite from '@/mixins/site'
import { Cart, CartItem } from '@/store/cart/types'
import { ActiveCategory, Model } from '@/store/editor/types'
import {
  blankCustomer,
  blankOrderCustomer,
  blankOrderParty,
} from '@/store/orders/constants'
import { IOrderCustomer } from '@/store/orders/types'
import { INewInquiry, IInquiryItem, IInquiry } from '@/store/inquiry/types'
import { blankInquiryContact } from '@/store/inquiry/constants'
import Vue from 'vue'
import { namespace } from 'vuex-class'
import Multiselect from 'vue-multiselect'
import { ResourcePermission } from '@/store/security/types'
import { ResponseArray } from '../../../store/types'
import { blankCartItem } from '@/store/cart/constants'

const INQUIRY_CUSTOMER_TAB = 0
const INQUIRY_ITEMS_TAB = 1
const INQUIRY_VALIDATED = 2

const nsCart = namespace('cart')
const nsInquiry = namespace('inquiries')
const nsOrderState = namespace('order-state')
const nsSearch = namespace('search')
const nsMultiplier = namespace('multiplier')

@Component({
  components: {
    CustomerForm,
    CartItems,
    'product-finder': ProductFinder,
    Loading,
    Multiselect,
    InquiryCommentsForm,
  },
})
export default class extends Mixins(MxSite) {
  @nsCart.Action('saveCartItem')
  private saveCartItem: any

  @nsMultiplier.Getter('getMultiplierPrice')
  private getMultiplierPrice: any

  @nsInquiry.Action('fetchCustomers')
  private fetchCustomers: any

  @nsInquiry.Getter('customers')
  public customers!: ResponseArray<IOrderCustomer>

  @nsCart.Getter('cart')
  public cart!: Cart

  @nsInquiry.Getter('currentCustomer')
  public currentCustomer!: Cart

  @nsInquiry.Action('addInquiry')
  private addInquiry: any

  @nsInquiry.Action('saveInquiry')
  private saveInquiry: any

  @nsInquiry.State('activeInquiry')
  private activeInquiry: any

  @nsInquiry.State('inquiryEditorOpenOnItemsTab')
  private inquiryEditorOpenOnItemsTab!: boolean

  @nsInquiry.State('isSubmittingInquiry')
  public isSubmittingInquiry!: boolean

  @nsOrderState.State('customerShipTos')
  public customerShipTos!: IOrderCustomer[]

  @nsInquiry.State('submissionError')
  private submissionError!: string

  @nsInquiry.Action('resetInquiry')
  private resetInquiry: any

  @nsOrderState.Action('setProductClassActive')
  private setProductClassActive!: any

  @nsOrderState.Action('toggleProductClassOpen')
  public toggleProductClassOpen!: any

  @nsOrderState.Action('setProductActive')
  private setProductActive!: any

  @nsOrderState.State('activeItem')
  public activeItem!: ActiveCategory

  @nsOrderState.Action('setManufacturingSeriesActive')
  private setManufacturingSeriesActive!: any

  @nsOrderState.Action('toggleManufacturingSeriesOpen')
  public toggleManufacturingSeriesOpen!: any

  @nsInquiry.State('inquiryDocuments')
  private inquiryDocuments: any

  @nsInquiry.Action('fetchDocuments')
  private fetchDocuments: any

  @nsSearch.Action('getVisibleModelsByPcn')
  private getVisibleModelsByPcn: any

  @Watch('activeInquiry')
  public handleInquiryAdded(newInquiry) {
    if (newInquiry.InquiryId) {
      this.$router.push({
        name: 'inquiry_summary',
        params: { inquiryId: newInquiry.InquiryId },
      })
    }
  }

  @Watch('submissionError')
  public alertSubmissionError(newError) {
    if (newError) {
      this.toastError(newError)
    }
  }

  public sameAddress = false
  public tabIndex = 0
  public customerShipToFormRef
  public customerBillToFormRef

  public showModelFinder = false
  public customerShipTo = blankOrderCustomer
  public customerBillTo = blankOrderCustomer
  public submitting = false
  public countries = []
  public states = []
  public selectedSalesRep: ResourcePermission | null = null
  public inquiryCommentsFormRef
  public inquiryContact = blankInquiryContact
  public contactErrors: any = {}

  public handleSameAddress(checked: boolean) {
    this.sameAddress = checked
  }

  public async mounted() {
    this.setOverlayShowing(true)
    this.initializeForm().then(() => {
      this.setOverlayShowing(false)
    })
  }

  public async initializeForm() {
    this.resetInquiry()
    this.inquiryContact = _.merge({}, blankInquiryContact)

    this.customerShipToFormRef = this.$refs.customerShipToForm as Vue
    this.customerBillToFormRef = this.$refs.customerBillToForm as Vue
    this.inquiryCommentsFormRef = this.$refs.inquiryComments as Vue

    await this.fetchCustomers('')
    await this.fetchCountries()
    await this.fetchUSStates()
    if (this.$route.params.fromInquiry) {
      await this.setInquiry(this.activeInquiry)
      if (this.inquiryEditorOpenOnItemsTab) {
        this.tabIndex = INQUIRY_ITEMS_TAB
        this.$store.commit('inquiries/inquiryEditorOpenOnItemsTabSet', false)
      } else {
        await this.$nextTick()
        this.tabIndex = INQUIRY_CUSTOMER_TAB
      }
    }
  }

  public async setInquiry(inquiry: IInquiry) {
    if (!inquiry) {
      return
    }

    const customerBillTo = {
      ...blankCustomer,
      ...this.customerBillToFormRef.customers.find(c => c.customerNo === inquiry.CustomerNumber),
      address: {
        Name: inquiry.BillToParty.Name,
        Address1: inquiry.BillToParty.Address1,
        Address2: inquiry.BillToParty.Address2,
        City: inquiry.BillToParty.City,
        State: inquiry.BillToParty.State,
        Zip: inquiry.BillToParty.Zip,
        Phone: inquiry.BillToParty.Phone,
        Country: inquiry.BillToParty.Country,
        Email: inquiry.BillToParty.Email,
        FirstName: inquiry.BillToParty.FirstName,
        LastName: inquiry.BillToParty.LastName,
      },
    }
    const customerShipTo = {
      ...blankCustomer,
      address: {
        Name: inquiry.ShipToParty.Name,
        Address1: inquiry.ShipToParty.Address1,
        Address2: inquiry.ShipToParty.Address2,
        City: inquiry.ShipToParty.City,
        State: inquiry.ShipToParty.State,
        Zip: inquiry.ShipToParty.Zip,
        Phone: inquiry.ShipToParty.Phone,
        Country: inquiry.ShipToParty.Country,
        Email: inquiry.ShipToParty.Email,
        FirstName: inquiry.ShipToParty.FirstName,
        LastName: inquiry.ShipToParty.LastName,
      },
    }
    this.inquiryCommentsFormRef.populateComments(inquiry.Comments, inquiry.Contact)
    await this.fetchDocuments(inquiry.InquiryId).then(() => this.inquiryCommentsFormRef.populateFiles(this.inquiryDocuments))
    this.inquiryContact.JobName = inquiry.JobName ?? ''
    this.inquiryContact.Email = inquiry.Contact?.Email ?? ''
    this.inquiryContact.Name = inquiry.Contact?.Name ?? ''
    this.inquiryContact.Phone = inquiry.Contact?.Phone ?? ''
    this.customerShipToFormRef.customer = customerShipTo
    this.customerShipToFormRef.selectedCountry = customerShipTo.address.Country
    await this.customerShipToFormRef.handleCustomerSelect(customerShipTo)
    this.customerBillToFormRef.selectedDBCustomer = customerBillTo
    await this.customerBillToFormRef.handleCustomerSelect(this.customerBillToFormRef.selectedDBCustomer)
    const modelItems = await this.getVisibleModelsByPcn(inquiry.Items.map(x => x.MaterialNumber))
    for (const inquiryItem of inquiry.Items) {
      const model: Model = modelItems.List.filter((x: Model) => inquiryItem.MaterialNumber === x.PcnCatalogNumber)[0]
      const inquiryCharacteristics = inquiryItem.CharacteristicValues ?? []
      const subItems = inquiryItem.SubItems ?? []
      let price = 0
      if (model.Configurable) {
        price = inquiryItem.Price
      } else {
        price = this.getMultiplierPrice(
          model.PcnCatalogNumber,
          model.ProductHierarchy,
          model.TotalList,
        )
      }
      const cartItem: CartItem = {
        pcnCatalogNumber: model.PcnCatalogNumber || '',
        SapModelDescription: model.SapModelDescription || '',
        fingoodTpiMfgMod: model.FingoodTpiMfgMod || '',
        description:
          model?.Descriptions[0]?.toString() || model.SapModelDescription || '',
        quantity: inquiryItem.Quantity,
        price: price || 0,
        totalPrice: (price || 0) * inquiryItem.Quantity,
        imgThumbnail: model.Image?.ImagePath || '',
        shippingStrategyId: model.ShippingStrategyId || 0,
        originalPrice: model.TotalList || 0,
        productHierarchy: model.ProductHierarchy || '',
        inventory: model.Available || '',
        modelDetails: model.Details,
        leadTime: model.LeadTime,
        characteristics: inquiryCharacteristics,
        configurable: model.Configurable,
        configured: model.Configurable,
        subItems: subItems!,
        priceLocked: inquiry.Status === 'Approved',
      }
      if (cartItem.configurable) {
        cartItem.SapModelDescription = ''
        cartItem.description = ''
      }
      await this.saveCartItem({ cartItem })
    }
  }

  public async handleSalesRepSelect(salesRep: ResourcePermission | null) {
    this.fetchCustomers(salesRep)
  }

  async fetchCountries() {
    try {
      await this.$store.dispatch('common/fetchCountries', '')
      this.countries = this.$store.getters['common/countries']
    } catch (error) {
      console.error('Error fetching countries:', error)
    }
  }

  async fetchUSStates() {
    try {
      await this.$store.dispatch('common/fetchCountryStates', 'US') // get states for US for now
      this.states = this.$store.getters['common/countryStates']
    } catch (error) {
      console.error('Error fetching country states:', error)
    }
  }

  public updateNext(mod: number) {
    // Check if user is trying to go forward
    if (mod === 1) {
      // If the current step is customer verification
      if (this.tabIndex === INQUIRY_CUSTOMER_TAB) {
        // Verify customer
        if (!this.verifyCustomer()) {
          // If verification fails, cannot proceed
          return
        }
        // Move to next step
        this.tabIndex = INQUIRY_ITEMS_TAB
      } else if (this.tabIndex === INQUIRY_ITEMS_TAB) {
        if (!this.verifyItems()) {
          return
        }
        this.tabIndex = INQUIRY_VALIDATED
      } else if (this.tabIndex === INQUIRY_VALIDATED) {
        this.placeInquiry()
      }
    } else if (mod === -1) {
      // Decrementing the step index to move backward
      this.tabIndex -= 1
    }
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    })
  }

  private verifyItems(): boolean {
    // Check if items are present in the cart
    if (this.cart.items.length === 0) {
      // If no items, cannot proceed
      this.toastWarning('Order must include one or more items')
      return false
    }
    const unconfigured = this.cart.items.filter(s => s.configurable && !s.configured)
    if (unconfigured.length > 0) {
      this.toastWarning('Configurable materials must be completed')
      return false
    }
    return true
  }

  public itemNumberText(number: number) {
    return (number * 10 + '').padStart(6, '0')
  }

  public placeInquiry() {
    if (!this.verifyCustomer()) {
      this.tabIndex = INQUIRY_CUSTOMER_TAB
      return
    }
    if (!this.verifyItems()) {
      this.tabIndex = INQUIRY_ITEMS_TAB
      return
    }
    const confirmed = confirm('Please confirm you wish to place this inquiry')
    const comments = this.inquiryCommentsFormRef
      .validate().comments
      .filter((x) => x.value !== '')
      .map((x) => x.value)
    if (confirmed) {
      let itemNumber = 1
      const newInquiry: INewInquiry = {
        Files: this.inquiryCommentsFormRef.validate().files,
        InquiryFiles: this.inquiryCommentsFormRef.validate().inquiryFiles?.map((x: any) => x.Id) || [],
        BillToParty: {
          ...blankOrderParty,
          PartnerNumber: this.customerBillTo.customerNo,
          Name: this.customerBillTo.address.Name || '',
          Address1: this.customerBillTo.address.Address1,
          Address2: this.customerBillTo.address.Address2,
          City: this.customerBillTo.address.City,
          State: this.customerBillTo.address.State,
          Zip: this.customerBillTo.address.Zip,
          Country: this.customerBillTo.address.Country,
          Phone: this.customerBillTo.address.Phone,
        },
        ShipToParty: {
          ...blankOrderParty,
          PartnerNumber:
            this.customerShipTo.customerNo || this.customerBillTo.customerNo,
          Address1: this.customerShipTo.address.Address1,
          Address2: this.customerShipTo.address.Address2,
          City: this.customerShipTo.address.City,
          State: this.customerShipTo.address.State,
          Zip: this.customerShipTo.address.Zip,
          Country: this.customerShipTo.address.Country,
          Phone: this.customerShipTo.address.Phone,
          Name:
            this.customerShipTo.companyName || this.customerShipTo.address.Name,
        },
        Comments: comments,
        Contact: this.inquiryContact,
        JobName: this.inquiryContact?.JobName,
        Items: this.cart.items.filter(x => x.pcnCatalogNumber).map(s => {
          const item: IInquiryItem = {
            InquiryItemId: 0,
            MaterialNumber: s.pcnCatalogNumber,
            Description: s.description,
            Quantity: s.quantity,
            Price: s.price,
            TotalPrice: s.totalPrice,
            QuantityUnit: 'EA',
            CharacteristicValues: s.characteristics,
            ItemCount: s.subItems?.length ?? 0,
            SubItems: s.subItems?.map(i => { return { ...i, ItemNumber: this.itemNumberText(itemNumber++) } }),
          }
          item.ItemNumber = (item.ItemCount ?? 0) > 0 ? item.SubItems[0].ItemNumber : this.itemNumberText(itemNumber++)
          return item
        }),
      }
      if (this.$route.params.fromInquiry) {
        this.saveInquiry({ inquiryId: this.activeInquiry.InquiryId, inquiry: newInquiry })
      } else {
        this.addInquiry(newInquiry)
      }
    }
  }

  public verifyCustomer() {
    this.contactErrors = {}
    if (!this.inquiryContact.JobName) {
      this.contactErrors.JobName = 'Job name is required'
    }
    if (!this.inquiryContact.Name) {
      this.contactErrors.Name = 'Contact name is required'
    }
    this.customerBillTo = {
      ...blankCustomer,
      ...this.customerBillToFormRef.validate(),
    }
    if (!this.sameAddress) {
      this.customerShipTo = {
        ...blankCustomer,
        ...this.customerShipToFormRef.validate(),
      }
    } else {
      this.customerShipTo = {
        ...blankCustomer,
        ...this.customerBillToFormRef.validate(),
      }
    }

    if (Object.keys(this.contactErrors).length !== 0) {
      return false
    }

    if (
      (this.customerShipTo.customerNo !== '' ||
        this.customerShipTo.address.Name !== '') &&
      this.customerBillTo.customerNo !== ''
    ) {
      return true
    }

    return false
  }

  public findModel() {
    this.showModelFinder = true
  }

  public closeModelFinder() {
    this.showModelFinder = false
  }

  public async addBlankItem() {
    this.saveCartItem({ cartItem: { ...blankCartItem } })
      .catch(() => {
        this.toastError('Fail to add item to Order')
      })
  }

  public customLabel({
    Id,
    ResourceName,
  }: {
    Id: string
    ResourceName: string
  }) {
    return Id ? `${ResourceName} - ${Id}` : ResourceName
  }

  public formatPhoneNumber() {
    const digitsOnly = this.inquiryContact.Phone.replace(/\D/g, '')
    this.inquiryContact.Phone = digitsOnly.replace(
      /^(\d{3})(\d{3})(\d{4})$/,
      '($1) $2-$3',
    )
  }

  public onBrowse() {
    this.showModelFinder = true
  }
}
</script>

<style>
.non-clickable-tab {
  pointer-events: none;
  cursor: default;
  /* Additional styling as needed */
}
</style>
